/*
 This file contains constants, enumerated types and ...
 Some of these reflect AIL and therefore ImageServer specific coding.

 Notes:
 element class names: although the css explictly uses the values, use these constants in the code;
 remember if you change the css value that you need to change these, and visa-versa
 */

const us = {};

us.idROOT = 'uscope'; // the default viewer root node - note that this may be replaced by VIL settings
us.idHashROOT = '#uscope'; // the default viewer root node with # prepended
us.clsROOTSTYLE = 'us_rootstyle'; // additional class on the root div to bring in uScope styling

// FB 23050: Some images, in some browsers (IE, FF occasionally) exhibit a "tearing" effect when rotation is applied.
// Setting this flag will cause the renderer in viewportAP to offset the tiles 1px closer to their counterpart, closing
// the gap. NOTE that this makes the images overlap by 1px. This could cause distortion, but we haven't been able to
// discern it.
// FB 23074: We found out how to discern the offset! Setting the below to true causes all tiles to be shifted, causing
// annotations to be shifted up and to the left!
us.EXPAND_TILE_SIZE = true;
us.REQUEST_LARGER_TILES = false;

us.clsPANEL = 'us_panel'; // class for all uscope panels
us.clsPANELCLICKCLOSE = 'us_panelclickclose'; // class for all uscope panels that should be closed when the user clicks on the view
us.clsTRANSPARENT = 'us_transparent'; // class for transparency

us.idTOPTOOLBARV = 'us_toptoolbar_v'; // toolbar vertical
us.idIATOOLBAR = 'us_iatoolbar'; // toolbar for image analysis panels

us.idMSGPANEL = 'us_msgPanel';

us.clsIMAGETOOLBAR = 'us_clsimagetoolbar'; // image toolbar
us.clsIMAGETOOLBARSTATE = 'us_clsimagetoolbarstate'; // image toolbar state indicator div
us.clsIMAGETOOLBARBTN = 'us_clsimagetoolbarbtn'; // image toolbar button class
us.clsIMAGETOOLBARSPC = 'us_clsimagetoolbarspc'; // image toolbar spacer vertical bar
us.clsTBCLOSEIMAGE = 'us_tbcloseimage'; // image toolbar: close image button
us.clsTBPINNED = 'us_tbpinned'; // image toolbar: pinned

us.clsTBCONTROL = 'us_tbcontrol'; // image toolbar: control slide indicator
us.clsTBPREVSLIDE = 'us_tbprevslide'; // image toolbar: previous slide
us.clsTBNEXTSLIDE = 'us_tbnextslide'; // image toolbar: next slide

us.clsTBBUTTON = 'us_tbbutton'; // toolbar button class
us.idTBRESIZE = 'us_tbresize'; // toolbar resize button

us.TBANNOTPANEL = 'us_tbannotpanel'; // toolbar annotation panel open icon

us.TBRASTEROPEN = 'us_tbrasteropen'; // toolbar raster panel open icon

us.idTBMULTIVIEW = 'us_tbmultiview'; // toolbar tiling options button
us.TBISCOPE = 'us_tbimagescope'; // toolbar open-in-imagescope button
us.TBSNAPSHOT = 'us_tbsnapshot'; // toolbar snapshot button

us.clsRBBUTTON = 'us_rbbutton'; // region toolbar button class
us.REGTBREDRAW = 'us_regtbredraw'; // context menu redraw
us.REGTBCOPY = 'us_regtbcopy'; // context menu region copy
us.REGTBMOVE = 'us_regtbmove'; // context menu regioncopy

/* image adjustment panel */
us.idIMGADJPANEL = 'us_imgadjpanel';
us.idBRIGHTSETTING = 'us_idbrightsetting';
us.idCONTRASTSETTING = 'us_idcontrastsetting';
us.BRIGHTICON = 'us_brighticon';
us.CONTRASTICON = 'us_contrasticon';
us.TBIMGADJOPEN = 'us_tbimgadjopen'; // toolbar annotation panel open icon

/* annotation panel */
us.clsAPBUTTON = 'us_apbutton'; // annot panel button class
us.idANNOTPANEL = 'us_annotpanel'; // ann panel container div
us.APANNOTARROW = 'us_apannotarrow'; // ann panel draw arrow
us.APANNOTRECT = 'us_apannotrect'; // ann panel draw rectangle
us.APANNOTPEN = 'us_apannotpen'; // ann panel draw pen
us.APANNOTNEGPEN = 'us_apannotnegpen'; // ann panel draw negative pen
us.APANNOTPIN = 'us_apannotpin'; // ann panel draw pin
us.APANNOTPOLY = 'us_apannotpoly'; // ann panel draw ploygon

us.APANNOTCALIPER = 'us_apannotcaliper'; // ann panel draw caliper
us.APANNOTREPORT = 'us_apannotreport'; // ann panel report region button
us.APANNOTELLIPSE = 'us_apannotellipse'; // ann panel draw ellipse
us.APANNOTTEXT = 'us_apannottext'; // ann panel freetext tool
us.APTRASH = 'us_apannottrash'; // ann panel trash can for annot delete
us.APANNOTCOLOR = 'us_apannotcolor'; // ann panel color picker
us.APNOTE = 'us_apnote'; // ann panel note

us.idCLRPICKPANEL = 'us_clrpickpanel'; // color picker panel
us.idCLRPICKDIV = 'us_clrpickdiv'; // container for color squares
us.clsCLRPICKGRID = 'us_clrpickgrid'; // color picker panel
us.idCLRPCKBAR = 'us_clrpickbar'; // color bar of selected color

us.idANNAVDIV = 'us_anavdiv'; // container for annot nav elements
us.clsANAVBUTTON = 'us_anavbutton'; // annotation nav button class
us.ANAVPREV = 'us_anavprev'; // annav panel icon for aprevious region
us.idANAVCURRENT = 'us_anavcurrent'; // annav panel icon for current selection icon
us.ANAVNEXT = 'us_anavnext'; // annav panel icon for next region
us.clsBLANKBTN = 'us_blankbtn';

us.clsANAVCURRENT = 'us_clsANAVCURRENT'; // annav panel icon for current selection icon

// -------------------------------------------------------------------------------------------------
us.idSETTINGSTABS = 'us_settingstabs'; // settings/options tab
us.idTABPREFERENCES = 'us_preferences'; // tab preferences

us.idTABACTIONS = 'us_actions'; // tab for use actions
us.idLINKTEXTBOX = 'us_linktextbox';

us.idTABREPORT = 'us_report'; // tab for report options
us.idREPORTFIXEDDIV = 'us_idfixedreportdiv';
us.idREPORTFIXEDWIDTH = 'us_idreportwidth';
us.idREPORTFIXEDHEIGHT = 'us_idreportheight';
us.clsREPORTTYPE = 'us_reporttype'; //

us.idTABIMAGEINFO = 'us_imageinfo'; // tab image info
us.idTABPERFORMANCE = 'us_performance'; // tab performance
us.idTABHOTKEYS = 'us_hotkeys'; // tab hotkeys
us.clsSETCHOICE = 'us_setchoice'; //
us.clsSETBUTTON = 'us_setbutton'; // style of visibility buttons

us.idHMCLEARBTN = 'us_idhmclearbtn'; // heat map clear btn
us.clsVIZCHECKBOX = 'us_vizcheckbox'; // visibility checkboxes
us.idVIZALLCHECKBOX = 'us_vizallcheckbox'; // visibility all checkbox
us.idOPTIONSBTN = 'us_idoptionsbtn'; // options btn

us.clsPREFBUTTON = 'us_prefbutton'; // style of preference buttons
us.idPREFLABELROTBTN = 'us_prefsavelabelbtn'; //
us.idPREFQUALITYSLIDER = 'us_qualitySlider'; //
us.idCONSOLEBUTTON = 'us_consolebutton'; //
us.idPREFDEFAULTBTN = 'us_prefdefaultbtn'; //
us.idVISDEFAULTBTN = 'us_visdefaultbtn'; //
us.idRPTDEFAULTBTN = 'us_rptdefaultbtn'; //

us.idIMAGEINFODIV = 'us_imageinfodiv';
us.idCOPYLINKBTN = 'us_copylinkbtn'; // button to copy image link
us.idLINKIMAGE = 'us_imglink'; // link icon used on button

us.idPTESTREPORTBTN = 'us_ptestreportbtn'; // performance testing
us.idPTESTRUNBTN = 'us_ptestrunbtn'; // run
us.clsPERFTESTOPTION = 'us_ptestoption'; // radio buttons
us.clsPERFTESTINTERVAL = 'us_ptestinterval'; // radio buttons
us.idPERFTESTINTERVAL = 'us_idptestinterval';
us.idPTESTSHOWBTN = 'us_ptestshowbtn'; //

us.idADVANCEDPANEL = 'us_advancedpanel'; // advanced options panel
us.idADVCONSOLE = 'us_advconsole'; //

us.clsADVBUTTON1 = 'us_advbutton1';
us.clsADVBUTTON2 = 'us_advbutton2';

us.idTEXTEDITPANEL = 'us_texteditpanel'; // text edit panel

us.idDBGCONSOLE = 'us_debugconsole'; // debug console panel
us.idDBGCONSOLELOG = 'us_debugconsolelog';
us.idDBGSWITCHPANEL = 'us_dbgswitchpanel'; // debug switches panel

// -------------------------------------------------------------------------------------------------

us.clsOVERLAY = 'us_overlay'; // for elements place on top of viewport tiles and above graphics
us.clsSUPEROVERLAY = 'us_superoverlay'; // for elements placed on top of overlay class elements

us.clsOUTERVIEWPORT = 'us_outerviewport'; // container div for the image viewport that holds overlays
us.clsDotOUTERVIEWPORT = '.' + us.clsOUTERVIEWPORT;
us.clsVIEWPORT = 'us_viewport'; // the image viewport class
us.clsDotVIEWPORT = '.' + us.clsVIEWPORT;

us.clsEDGEDIV = 'us_edgediv'; // edge divs

us.clsANNOTDIV = 'us_paper'; // container for Raphael graphics
us.clsDotANNOTDIV = '.' + us.clsANNOTDIV;
us.clsGRAPHICS = 'us_graphics';

// -------------------------------------------------------------------------------------------------

us.clsDIVTHUMBNAIL = 'us_thumbnail';
us.clsIMGTHUMBNAIL = 'us_imgThumbnail';
us.clsDIVVIEWFINDER = 'us_thumbviewfinder';
us.clsDIVTHUMBHOVER = 'us_clsDIVTHUMBHOVER';
us.idTHHOVERCHECKBOX = 'us_idTHHOVERCHECKBOX';

us.CVSHEATMAP = 'us_cvsheatmap';

us.clsDIVLABEL = 'us_label';
us.clsIMGLABEL = 'us_imgLabel';

us.ROTATE = 'us_rotate'; // prefix to rotation style

us.clsDIVMARKER = 'us_marker';
us.clsIMGMARKER = 'us_imgMarker';

us.clsDIVZOOMSLIDER = 'us_zoomSlider';
us.clsDIVZOOMCTL = 'us_zoomControl';
us.clsDIVZOOMBTNS = 'us_zoomButtons';
us.clsDIVZOOMBTN = 'us_zoomButton';

us.clsDIVMAG = 'us_magnifier';
us.clsDIVIMGWRAP = 'us_imgMagWrapper';
us.clsIMGMAG = 'us_imgMag';
us.clsIMGREGION = 'us_imgRegion'; // generic image region
us.clsDIVMAGTAB = 'us_magTab';
us.clsMAGXHAIR = 'us_clsMagXHair';

us.clsDIVOUTERSCALEBAR = 'us_scalebarouter';
us.clsDIVSCALEBAR = 'us_scaleBar';
us.clsDIVSCALETEXT = 'us_scaleText';
us.clsDIVSCALEMAG = 'us_scaleMag';
us.clsSBROTKNOB = 'us_sbrotknob';
us.clsSBROTKNOBANGLE = 'us_sbrotknobangle';

us.clsROTATIONDIV = 'us_rotationDiv';
us.clsROTATIONDIAL = 'us_rotationDial';
us.clsROTATEPRESET = 'us_rotatePreset';

us.clsDIVGUAGES = 'us_guagesdiv'; // tile meter
us.clsDIVGUAGE = 'us_guagediv';
us.clsGUAGETEXT = 'us_guagetext';
us.clsGUAGETILES = 'us_guagetiles';
us.clsGUAGECELL = 'us_guagecell';
us.clsGUAGETILETEXT = 'us_guagetiletext';
us.clsGUAGEVIEWTEXT = 'us_guageviewtext';

us.clsGUAGEREF = 'us_guageref'; // view refresh meter

us.clsAPANDIV = 'us_autoPanDiv'; // the auto pan indicator at the view center
us.clsAPANCUR = 'us_autoPanCursor'; // the auto pan cursor
// -------------------------------------------------------------------------------------------------
us.clsTUNINGWINDOW = 'us_clstuningwindow';

// -------------------------------------------------------------------------------------------------

// constants
us.Rad2Deg = 180.0 / Math.PI;
us.Deg2Rad = Math.PI / 180.0;
us.PI_2 = Math.PI / 2.0;

// -------------------------------------------------------------------------------------------------
// use of these adds clarity to the code
us.WITHFORCE = true;
us.WITHOUTFORCE = false;

us.FORCE_VIEWREFRESH = true;
us.DONT_FORCE_VIEWREFRESH = true;

us.DO_HIGHLIGHT = true;
us.DONT_HIGHLIGHT = true;

// -------------------------------------------------------------------------------------------------
// uScope custom events, triggers
// --------------------------------------------------
//    TO VIL        note: VIL watches for these events so take care if renaming
// --------------------------------------------------
us.evAJAXERROR = 'us_evAJAXERROR'; // parms: {imageId: @NUM, request: ImageServerRequest, jqXHR: jqXHR}
us.evIMAGEREADY = 'us_evIMAGEREADY'; // parms: {imageId: @NUM, uScopeIdx: NUM, status: true/false}
us.evIMAGECLOSE = 'us_evIMAGECLOSE'; // parms: {imageId: @NUM} toolbar button close event

// note: VIL watches for these events so take care if renaming
us.evOPENNEXTSLIDE = 'us_evOPENNEXTSLIDE'; // parms: {NONE}
us.evOPENPREVSLIDE = 'us_evOPENPREVSLIDE'; // parms: {NONE}

// --------------------------------------------------
//    INTERNAL
// --------------------------------------------------
// user preference actions
us.evUSERPREFSREADY = 'us_evUSERPREFSREADY';
us.evUSERPREFDEFAULTREPORT = 'us_evUSERPREFDEFAULTREPORT';
us.evUSERPREFDEFAULTLABELROT = 'us_evUSERPREFDEFAULTLABELROT';
us.evUSERPREFDEFAULTTHUMBHOVER = 'us_evUSERPREFDEFAULTTHUMBHOVER';

// general purpose
us.evIMAGEUPDATE = 'us_evIMAGEUPDATE'; // parms: { } // image added, removed, replaced
us.evVIEWCHANGE = 'us_evVIEWCHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, desc: STR, x: NUM, y: NUM, zoom: NUM, angleDeg: NUM }
us.evMOUSECHANGE = 'us_evMOUSECHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, x: NUM, y: NUM }
us.evIMAGESELECTED = 'us_evIMAGESELECTED'; // parms: {imageId: @NUM, uScopeIdx: NUM}
us.evMODECHANGE = 'us_evMODECHANGE'; // parms: {navMode: NUM }

us.evIMAGEROTATE = 'us_evIMAGEROTATE'; // parms: {imageId: @NUM, uScopeIdx: NUM, angleDeg: NUM },  imageId = "@0" or uScopeIdx = -1, all images rotated
us.evNAVMODEHALT = 'us_evNAVMODEHALT'; // parms: {imageId: @NUM, uScopeIdx: NUM },  imageId = "@0" or uScopeIdx = -1, halt navigation of all images

// events fired to request something to happen
us.evREGIONSELECT = 'us_evREGIONSELECT'; // select a region by rfId, parms { imageId: @NUM, rfId: NUM, bReposition: true|false, bSaveSel: true|false }
// when a region is selected, deleted, or added the event us.evANNOTCHANGE is fired - which could be in response to this event or a user action
us.evLAYERSELECT = 'us_evLAYERSELECT'; // select a layer by layerId, parms {imageId: @NUM, LayerId: NUM}

us.evVIEWRESIZE = 'us_evVIEWRESIZE'; // parms: {}
us.evRENDERCOMPLETE = 'us_evRENDERCOMPLETE'; // parms: {imageId: @NUM}

/// ////////////////////////////////////////////////////
us.evGETMARKUPSTATE = 'us_evGETMARKUPSTATE'; // parms { imageId: @NUM }
us.evGETMARKUPSTATE_RESP = 'us_evGETMARKUPSTATE_RESP'; // parms { imageId: @NUM, show: true|false, globalShow: true|false, imageHasMarkups: true|false }
us.evMARKUPCHANGE = 'us_evMARKUPCHANGE'; // markup state change;  parms { imageId: @NUM, show: true|false }

us.evREGIONDELETE = 'us_evREGIONDELETE'; // delete a region; parms { imageId: @NUM, regionId: NUM }
/// ////////////////////////////////////////////////////

// rasterscan events
us.evSPACEBAR = 'us_evSPACEBAR';
us.evRASTERPROGRESS = 'us_evRASTERPROGRESS';

// uScope constants
us.kDEF_TILE_POS = -4000; // constant default left,top tile position
us.kDEF_TILE_POS_PX = us.kDEF_TILE_POS + 'px';

us.kREFRESH_RATE = 500; // Used to rate limit image requests. TODO: Make a priority queue for image requests

// -------------------------------------------------------------------------------------------------
// enums kept in sync with AIL, cViewport,  DataServer
us.eAICCaptureType = { // image capture type
  aic_i_BF: 0, // Bright Field
  aic_i_FL: 1, // FLuorescence
  aic_i_MIX: 2 // BF and FL (fusion)
};
us.captureNames = ['BrightField', 'Fluorescence', 'Fused'];

// -------------------------------------------------------------------------------------------------
// ANNOTATIONS
// -------------------------------------------------------------------------------------------------
// note: do not change the type order as ImageScope/Viewport depend upon it
//        and do not change these strings as pin drop navigation depend upon them (at least 'pin')
// note that the ruler creation is replaced by the caliper in this viewer
//        but is drawn if present in annotations from an older view

us.eAnTypes = { // these annotation types are used as indexes into us.anShapes
  pen: 0,
  rect: 1,
  ellipse: 2,
  arrow: 3,
  ruler: 4,
  pin: 5,
  caliper: 6,
  text: 7,
  report: 8,
  polygon: 9,
  negpen: 10
};

us.anShapes = Object.keys(us.eAnTypes);
us.eAnAnalysis = [1, 1, 0, 0, 0, // index to anTypes that can be analyzed - IMPORTANT TO KEEP IN ORDER WITH eAnTypes!
  0, 0, 0, 0,
  1, 0, 0];
us.kREGIONTYPES = us.anShapes.length; // number of region types

us.anLayerTypesSupported = {}; // annotation layer types supported
us.anLayerTypes = {
  aafinput: 1,
  aafinal: 2,
  aafresult: 3,
  manual: 4, // user drawn
  zstack: 5,
  cwsregion: 6,
  track: 7,
  report: 8 // report layer for report region
};

// interpretation of status returned from ALGORITHMRUN   //todo: move to appropriate local
us.algoRunStatus = {'error': -1, 'queued': 0, 'active': 1, 'completed': 2, 'canceled': 3};
us.algoRunStatusStr = ['queued', 'active', 'completed', 'canceled'];
us.algoRunStatusStr[-1] = 'error';

us.AnnotLayerName = 'Annotation'; // the A-layer, the name of the layer to hold regions with colors other than that of the layer
us.AnnotLayerRGB = '#0000FF'; // default RGB ordered color for A-layer (layer named "Annotation")
us.ReportLayerName = 'Report Image'; // the R-layer, the name of the layer to hold the one and only report region
us.ReportLayerRGB = '#FF0000'; // default RGB ordered color for R-layer (layer named "Report Image")

us.colorPalette = [ // hex RGB ordered formatted and configured for colorPicker
  '#ffaaaa', '#ffd4aa', '#ffffaa', '#d4ffaa', '#aaffaa', '#aaffd4', '#aaffff', '#aad4ff', '#aaaaff', '#d4aaff', '#ffaaff', '#ffaad4', '#ffffff',
  '#ff5656', '#ffaa56', '#ffff56', '#aaff56', '#56ff56', '#56ffaa', '#56ffff', '#56aaff', '#5656ff', '#aa56ff', '#ff56ff', '#ff007f', '#cfcfcf',
  '#ff0000', '#ff7f00', '#ffff00', '#7fff00', '#00ff00', '#00ff7f', '#00ffff', '#007fff', '#0000ff', '#7f00ff', '#ff00ff', '#ff007f', '#8f8f8f',
  '#bf0000', '#bf5f00', '#bfbf00', '#5fbf00', '#00bf00', '#00bf5f', '#00bfbf', '#005fbf', '#0000bf', '#5f00bf', '#bf00bf', '#bf005f', '#4f4f4f',
  '#7f0000', '#7f3f00', '#7f7f00', '#3f7f00', '#007f00', '#007f3f', '#007f7f', '#003f7f', '#00007f', '#3f007f', '#7f007f', '#7f003f', '#000000'];

// report region settings
us.eReportTypes = {
  FullRes_FixedDim: 0, // Full Resolution Image, Fixed Sized Report Region
  FullRes_UserDrawn: 1, // Full Resolution Image, User Drawn Report Region
  CurRes_FixedDim: 2, // Current Image Resolution, Fixed Sized Report Region
  CurRes_UserDrawn: 3 // Current Image Resolution,User Drawn Report Region
};

us.eReportSpec = {
  defReportType: 0, // default report types {eReportTypes}
  defWidthPx: 160, // default report width
  defHeightPx: 120, // default report height

  minDimPx: 50, // min and max width,height dims
  maxDimPx: 1600
};

// -------------------------------------------------------------------------------------------------
// COORDINATE SYSTEM DEFINITION
// -------------------------------------------------------------------------------------------------
// Note that this is a cheap means to differentiate
//        "normal" graphics coordinate system
//            ( with the origin at the top left, x-positive right, y-positive down)
//        from the open layers 3 coordinate system
//            ( with the origin at the top left, x-positive right, y-negative down)

us.coordSystemNORM = {x: 1, y: 1};
us.coordSystemOL = {x: 1, y: -1}; // xform to/from OL to Norm

// -------------------------------------------------------------------------------------------------
// NAVIGATION - for viewport and thumbnail event handlers
// -------------------------------------------------------------------------------------------------

us.eNavModes = { // navigation modes -really related to interpretation of the mouse actions
  nmNone: 0, // default
  // image nav modes
  nmDragImage: 1,
  nmThumbDragImage: 2,
  nmZoom: 3, // TODO: unused
  nmPinchZoom: 5,
  nmSmoothZoom: 6, // TODO: unused
  // annotation "nav" modes
  nmAnnotPin: 7,
  nmAnnotArrow: 8,
  nmAnnotRect: 9,
  nmAnnotEllipse: 10,
  nmAnnotPen: 11,
  nmAnnotCaliper: 12,
  nmAnnotText: 13,
  nmAnnotReport: 14,
  nmAnnotPolygon: 15,
  nmAnnotNegPen: 16,

  nmRedrawStarting: 17, // region redraw
  nmRedraw: 18,

  nmAutoPan: 19,
  nmRasterScan: 20,

  nmRotatingOverlay: 21, // only scalebar rotation so far

  nmNOMORE: 22
};

// -------------------------------------------------------------------------------------------------
// multiple image settings
us.multiSpecs = {
  maxImages: 4 // maximum number of images (views)
};
// -------------------------------------------------------------------------------------------------
//    layout settings for overlay visuals (elements that are above the viewport)
// These settings apply for all open images.

us.kOVERLAY_ELEMENT_SPACE = 2; // space in pixels from the viewport boundary and between adjacent elements

// -------------------------------------------------------------------------------------------------
// annotation elements
us.pinSpecs = {
  'coords': [
    14.676, -30.3985, 14.642, -31.3935, 14.542, -32.3875, 14.373, -33.3725, 14.138, -34.3445, 13.839, -35.2905, 13.47, -36.2275, 13.04, -37.1325, 12.551,
    -38.0025, 12.007, -38.8335, 11.395, -39.6425, 10.744, -40.3895, 10.038, -41.0985, 9.285, -41.7585, 8.496, -42.3605, 7.658, -42.9145, 6.78, -43.4115,
    5.877, -43.8435, 4.962, -44.2075, 3.996, -44.5165, 3.025, -44.7555, 2.053, -44.9255, 1.059, -45.0295, 0.047, -45.0675, -0.943, -45.0375, -1.938, -44.9405,
    -2.924, -44.7765, -3.898, -44.5445, -4.856, -44.2455, -5.785, -43.8835, -6.682, -43.4625, -7.554, -42.9775, -8.406, -42.4235, -9.199, -41.8275, -9.957,
    -41.1735, -10.669, -40.4695, -11.325, -39.7275, -11.943, -38.9235, -12.494, -38.0965, -12.989, -37.2315, -13.425, -36.3305, -13.801, -35.3965, -14.107,
    -34.4535, -14.35, -33.4845, -14.527, -32.4905, -14.635, -31.4985, -14.676, -30.5115, -14.649, -29.5025, -14.556, -28.5035, -14.396, -27.5255, -14.168,
    -26.5525, -13.871, -25.5895, -13.512, -24.6565, -13.091, -23.7545, -12.604, -22.8735, -12.069, -22.0435, -11.47, -21.2405, -10.819, -20.4815, -10.119,
    -19.7675, -9.372, -19.1035, -8.58, -18.4895, -7.746, -17.9305, -6.874, -17.4285, -5.981, -16.9915, -5.208, -16.4705, -4.909, -15.5245, -4.609, -14.5735,
    -4.307, -13.6175, -4.006, -12.6635, -3.704, -11.7085, -3.399, -10.7445, -3.101, -9.8005, -2.798, -8.8425, -2.496, -7.8865, -2.195, -6.9325, -1.893, -5.9745,
    -1.597, -5.0385, -1.292, -4.0735, -0.994, -3.1295, -0.688, -2.1615, -0.39, -1.2165, -0.091, -0.2705, 0.211, -0.6505, 0.512, -1.6015, 0.818, -2.5715, 1.119,
    -3.5235, 1.417, -4.4665, 1.718, -5.4165, 2.02, -6.3745, 2.322, -7.3285, 2.624, -8.2825, 2.925, -9.2365, 3.226, -10.1875, 3.53, -11.1505, 3.832, -12.1045,
    4.132, -13.0535, 4.43, -13.9985, 4.734, -14.9595, 5.033, -15.9055, 5.444, -16.7625, 6.356, -17.1645, 7.249, -17.6325, 8.105, -18.1595, 8.907, -18.7315,
    9.681, -19.3665, 10.409, -20.0515, 11.09, -20.7835, 11.72, -21.5615, 12.296, -22.3815, 12.817, -23.2415, 13.272, -24.1225, 13.668, -25.0375, 14.002,
    -25.9835, 14.272, -26.9585, 14.469, -27.9235, 14.602, -28.9115
  ],
  'width': 29.352,
  'height': 44.797
};

us.labelSpecs = { // label settings
  'width': 100
};
us.zoomSpecs = {// zoom control settings
  'sliderMin': 0, // zoom slider min/max values
  'sliderMax': 200,
  'stepFactor': -0.2,

  'fitZoomMax': 200 // the maximum zoom that "Fit" is permitted
};

// -------------------------------------------------------------------------------------------------
//    annotation settings
us.annotSpecs = {
  minAnnotDim: 20, // minimum dimension of an annotation in pixels
  minPenPointDist: 3, // minimum distance between saved pen points

  fontSize: 14,
  strokeWidthTextBorder: 2,
  strokeWidthPin: 2,
  strokeWidth: 3,
  strokeWidthSel: 5,
  strokeWidthHiLight: 2,
  strokeWidthCopyMove: 4,

  fillOpacity: '0.2',

  textBBoxPad: 4,
  textBBoxRadius: 8
};

//    text edit settings
us.textEditSpecs = {
  'width': 300, // width, height in pixels of text entry panel
  'height': 200,
  'maxChars': 275, // limit imposed by dataserver is 1023; DS fails if send it more!
  'noteWidth': 44 // width in pixels of hover note
};

us.reDrawSpecs = { // region redraw tolerances
  'thinTolerance': 10,
  'startTolerance': 100,
  'skipTolerance': 10,
  'removeTolerance': 50
};

// -------------------------------------------------------------------------------------------------
//    analysis related

// Note that ImageServer has a limitation on the dimensions of its returned JPEG compressed image
// (currently clipping each dimension to 2000 pixels).
us.IMAGESERVER_MAXJDIM = 2000; // hardcoded ImageServer limitation on dims of JPEG

// types defined by cAAFParameterTypes in  AAFTypes.h
us.AAFParameterType = ['eInteger', 'eDouble', 'eString', 'eBool', 'eList', 'eMultiSelList', 'eDynamicList'];
us.AAFParameterTypeNames = {eInteger: 0, eDouble: 1, eString: 2, eBool: 3, eList: 4, eMultiSelList: 5, eDynamicList: 6};

// -------------------------------------------------------------------------------------------------
// objectiveColor - This function returns the industry standard color associated with a given magnification.
//    References:
//         color codes for objective lens:
//        http://zeiss-campus.magnet.fsu.edu/tutorials/objectivecolorcoding/
us.objectiveColors = [];
us.objectiveColor = function (mag) {
  const white = '#808080'; // because of BF and FL white and black backgrounds, change white color code to gray

  if (us.objectiveColors.length == 0) { // fill in the objective color array
    us.objectiveColors.push({'mag': 100, color: white}); // White
    us.objectiveColors.push({'mag': 83, color: white}); // White
    us.objectiveColors.push({'mag': 80, color: white}); // White

    us.objectiveColors.push({'mag': 63, color: '#0B4EA2'}); // Cobalt Blue
    us.objectiveColors.push({'mag': 60, color: '#0B4EA2'}); // Cobalt Blue

    us.objectiveColors.push({'mag': 50, color: '#007DC5'}); // Light Blue
    us.objectiveColors.push({'mag': 40, color: '#007DC5'}); // Light Blue

    us.objectiveColors.push({'mag': 32, color: '#10B050'}); // Green
    us.objectiveColors.push({'mag': 25, color: '#10B050'}); // Green

    us.objectiveColors.push({'mag': 20, color: '#00aa00'}); // Green
    us.objectiveColors.push({'mag': 16, color: '#10B050'}); // Green

    us.objectiveColors.push({'mag': 10, color: '#FFFF00'}); // Yellow

    us.objectiveColors.push({'mag': 6, color: '#FEB811'}); // Orange
    us.objectiveColors.push({'mag': 5, color: '#990033'}); // changed from original value of "#EF3449" to distinguish mag 4 and pyramid level mag 5 // Red
    us.objectiveColors.push({'mag': 4, color: '#EF3449'}); // Red

    us.objectiveColors.push({'mag': 2.5, color: '#A78D2C'}); // Brown
    us.objectiveColors.push({'mag': 2, color: '#A78D2C'}); // Brown

    us.objectiveColors.push({'mag': 1.25, color: '#231F20'}); // Black
    us.objectiveColors.push({'mag': 1.5, color: '#231F20'}); // Black
    us.objectiveColors.push({'mag': 1, color: '#231F20'}); // Black
  }

  for (let i = 0, clen = us.objectiveColors.length; i < clen; i++) {
    if (us.objectiveColors[i].mag == mag) {
      return us.objectiveColors[i].color;
    }
  }
  return white;
};

export default us;
